import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTimeFlies: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"time-flies, speed"} maskId="square-filled-radius-0-stroke-1-IconTimeFlies"><path fillRule="evenodd" clipRule="evenodd" d="M7 12C7 7.58172 10.5817 4 15 4C19.4183 4 23 7.58172 23 12C23 16.4183 19.4183 20 15 20C10.5817 20 7 16.4183 7 12ZM2 7H6V8H2V7ZM15.5 8V11.7929L18.2071 14.5L17.5 15.2071L14.5 12.2071V8H15.5ZM1 11.5H5V12.5H1V11.5ZM2 16H6V17H2V16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTimeFlies;
